<template>
  <div class="footer-container fixed-bottom" @click="logout">
      <div class="icon_footer_logout"></div>
      <div class="">ログアウト</div>
  </div>
</template>

<script>
export default {
  methods:{
    logout () {
      this.$emit("out-click");
    }
  }
}
</script>